import { render, staticRenderFns } from "./IoTDataClient.component.vue?vue&type=template&id=38732c1e&scoped=true"
import script from "./IoTDataClient.component.ts?vue&type=script&lang=js&external"
export * from "./IoTDataClient.component.ts?vue&type=script&lang=js&external"
import style0 from "./IoTDataClient.component.vue?vue&type=style&index=0&id=38732c1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38732c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38732c1e')) {
      api.createRecord('38732c1e', component.options)
    } else {
      api.reload('38732c1e', component.options)
    }
    module.hot.accept("./IoTDataClient.component.vue?vue&type=template&id=38732c1e&scoped=true", function () {
      api.rerender('38732c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/IoTDataClient.component.vue"
export default component.exports